import React from 'react';
import { Button } from './ui/button';
import { Calendar, Phone, ExternalLink } from 'lucide-react';
import { clinicInfo } from '../mock';

const Hero = ({ onBookNow }) => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      {/* Decorative background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-pink-200/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-200/30 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Logo */}
          <div className="flex justify-center lg:justify-start">
            <img
              src="https://customer-assets.emergentagent.com/job_wellness-hub-1076/artifacts/4wxgrb8d_WhatsApp%20Image%202026-04-06%20at%2011.12.14%20PM.jpeg"
              alt="Shubh Wellness Clinic Logo"
              className="w-full max-w-md h-auto rounded-2xl shadow-2xl"
            />
          </div>

          {/* Right Side - Text Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 bg-gradient-to-r from-teal-600 via-emerald-600 to-green-600 bg-clip-text text-transparent">
              Welcome to Shubh Wellness Clinic
            </h1>
            <p className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
              Your Path to Health and Wellness
            </p>
            <p className="text-lg md:text-xl text-gray-600 mb-6 leading-relaxed">
              Certified professionals providing exceptional massage therapy, physiotherapy, 
              osteopathy, acupuncture, and chiropractic care in Kitchener, Ontario.
            </p>
            
            {/* Direct Billing Badge */}
            <div className="inline-flex items-center bg-gradient-to-r from-green-100 to-emerald-100 border-2 border-green-300 rounded-full px-6 py-3 mb-8">
              <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="font-semibold text-green-700 text-lg">We Provide Direct Billing to Insurance</span>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
              <Button 
                size="lg" 
                className="cta-button group w-full sm:w-auto"
                onClick={onBookNow}
              >
                <Calendar className="mr-2 h-5 w-5 group-hover:scale-110 transition-transform" />
                Book Appointment
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                className="phone-button group w-full sm:w-auto"
                onClick={() => window.location.href = 'tel:5197481333'}
              >
                <Phone className="mr-2 h-5 w-5 group-hover:rotate-12 transition-transform" />
                Call: 519-748-1333
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
